export default {
    name: 'ชื่อ',
    surname: 'นามสกุล',
    contact: 'ติดต่อ',
    contactNo: 'เบอร์ติดต่อ',
    group: 'กลุ่ม',
    department: 'แผนก',
    status: 'สถานะ',
    line: 'ไลน์',
    createNewEmployee: 'สร้างพนักงานใหม่',
    updateEmployee: 'แก้ไขข้อมูลพนักงาน',
    profile: 'ข้อมูลส่วนตัว',
    citizenId: 'บัตรประชาชน/หนังสือเดินทาง',
    employeeNo: 'รหัสพนักงาน',
    gender: 'เพศ',
    male: 'ชาย',
    female: 'หญิง',
    dateOfBirth: 'วันเกิด',
    statusStart: 'วันเริ่มต้น',
    statusEnd: 'วันสิ้นสุด',
    branch: 'สาขา',
    role: 'ตำแหน่ง',
    email: 'อีเมล์',
    phoneNumber: 'เบอร์โทร',
    employment: 'การจ้างงาน',
    fullTime: 'พนักงานประจำ',
    probation: 'ทดลองงาน',
    quotaLeaveType: 'โค้วต้าการลา',
    usedLeaveType: 'วันลาคงเหลือ',
    leaveType: 'ประเภทการลา',
    day: 'วัน',
    permissionLevel: 'ผู้มีสิทธิ์อนุมัติการลา',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    msgImageSize: 'ขนาดภาพต้องอยู่ระหว่าง 25KB ถึง 200KB',
    msgErrorImageSize: 'ขนาดของรูปภาพต้องอยู่ระหว่าง 25KB เเละ 200KB',
    msgError: 'เกิดข้อผิดพลาด',
    congratulation: 'ยินดีด้วย',
    warning: 'เเจ้งเตือน',
    error: 'ข้อผิดพลาด',
    msgRequiredField: 'กรุณากรอกข้อมูล',
    msgExceededField: 'ข้อความเกิน 255 ตัวอักษร',
    msgRequiredEmail: 'กรุณากรอกอีเมล์',
    msgInvalidEmailFormat: 'รูปเเบบอีเมล์ไม่ถูกต้อง',
    msgExceededEmail: 'อีเมล์เกิน 255 ตัวอักษร',
    msgIncorrectPhoneNumber: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    approver1: 'ผู้อนุมัติลำดับที่ 1',
    approver2: 'ผู้อนุมัติลำดับที่ 2',
    cardNo: 'เลขบัตรพนักงาน',
    msgExceededCardNo: 'หมายเลขบัตรเกิน 10 ตัวอักษร',
    msgImageSizeZkt: 'ขนาดภาพต้องอยู่ระหว่าง 50KB ถึง 400KB',
    msgErrorImageSizeZkt: 'ขนาดของรูปภาพต้องอยู่ระหว่าง 50KB เเละ 400KB'
}
